import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { ProjectsToImport } from 'modules/project_management/lib/types'

export interface ImportProjectsConfirmModalProps {
  onClose: () => void
  onSubmit: (selectedProjects: ProjectsToImport[]) => Promise<void>
  selectedProjects: ProjectsToImport[]
}

const ImportProjectsConfirmModal = ({
  onClose,
  onSubmit,
  selectedProjects,
}: ImportProjectsConfirmModalProps) => {
  const title =
    selectedProjects.length === 1
      ? i18n.t('project_management.imports.modals.import_projects_confirmation.title.one', {
          count: selectedProjects.length,
        })
      : i18n.t('project_management.imports.modals.import_projects_confirmation.title.multiple', {
          count: selectedProjects.length,
        })

  return (
    <Modal
      illustration="document-edit"
      title={title}
      description={i18n.t(
        'project_management.imports.modals.import_projects_confirmation.description'
      )}
      onClose={onClose}
      onSubmit={() => onSubmit(selectedProjects)}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('project_management.imports.modals.import_projects_confirmation.cancel')}
          </Button>
          <Button submit>
            {i18n.t('project_management.imports.modals.import_projects_confirmation.submit')}
          </Button>
        </>
      }
    >
      <Box
        padding="s16"
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        borderRadius={{ all: 'abs006' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
      >
        <Text size="200">
          {i18n.t('project_management.imports.modals.import_projects_confirmation.new_projects')}
        </Text>
        <Text size="200">{selectedProjects.length}</Text>
      </Box>
    </Modal>
  )
}
export default ImportProjectsConfirmModal
